module.exports = __webpack_public_path__ + "media/src/images/partners/mhmk-56eb590201e33350e510510249ff1e9c.jpg";